// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bg-image{background-position:top;background-repeat:no-repeat;background-size:cover;position:relative;padding-bottom:0}.search-flight-modal{background:hsla(0,0%,60.4%,.2);backdrop-filter:blur(10px);border-radius:20px;width:1036px;max-width:calc(100% - 24px);padding:10px}@media(max-width:768px){.search-flight-modal{padding:12px}}.card{border-radius:8px}", ""]);
// Exports
module.exports = exports;
